module.exports = __webpack_public_path__ + "img/bici.73c12b22.png";